// extracted by mini-css-extract-plugin
var _1 = "SettingsSidebar-module__animateUploadProgressBarWidth--ykspa";
var _2 = "SettingsSidebar-module__animatedBackground--iDSwR";
var _3 = "SettingsSidebar-module__homeButton--nOlXH";
var _4 = "SettingsSidebar-module__section--Hx03w";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "homeButton", _4 as "section" }
